import Crum from '@/components/Crum';
import SupportBanner from '@/components/SupportCommon/SupportBanner';
import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import SupportTitle from '@/components/SupportCommon/SupportTitle';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import SupportTitleH5 from '@/componentsH5/SupportCommon/SupportTitle';
import { useGlobal } from '@/utils/useGlobal';
import { Table } from 'antd';
import css from './index.module.scss';

export default function OldSupportPolicy({ lang }: any) {
    const { useState, useEffect, isMobile, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const policyList = [
        {
            key: 'p1',
            text: 'Overview',
            isContainTable: true,
        },
        {
            key: 'p2',
            text: 'Warranty Period',
            isContainTable: true,
        },
        {
            key: 'p3',
            text: 'Return, Refund & Replacement Services',
            value: `
      3.1 Unconditional Returns Policy<br />
      a. Unconditional returns policy only apply to Orders placed on EcoFlow.com in the US region; customers can request a return within 30 days after receiving product;<br />
      b. For products purchased from other Channels EcoFlow does not accept unconditional returns, please contact your purchase channel first;<br />
      c. For unconditional returns, customers can request a refund after confirmation with EcoFlow customer service.<br />
      <br /><br />
      3.2 Requirements of Refunds & Replacements<br />
      a. For product and all accessories, no man-made damages are found;<br />
      b. All accessories and parts need to be sent back to EcoFlow with the main product;<br />
      c. Parts and accessories should be securely packaged for return delivery in order to ensure good condition and to prevent damage during transportation.<br />
      <br /><br />
      3.3 Product Returns Process<br />
      a. Providing your product has been received and it has been less than 30 calendar days, you can register your order in our return center: https://EcoFlow.returnscenter.com/. (Only available for the EcoFlow.com orders)<br />
      b. Our Support Team will determine whether your order is eligible. After confirming your order is eligible, they will give you a Return Material Authorization (RMA) number and provide you with a prepaid return shipping label (label to be determined by the support team). They will also provide instructions on how to properly package the product to return it safely. Do not ship the product until you have received the proper safety directions on how to ship the product. You must clearly mark the RMA number on the package and include your proof of purchase date with the product;<br />
      c. EcoFlow Tech will process your return request according to the return policy. For more details, please refer to our EcoFlow Lithium Battery Return Instructions:
      https://EcoFlow.com/pages/EcoFlow-lithium-battery-return-instruction;<br />
      d. Please do not return the items without the RMA confirmation from the EcoFlow Customer Support Team. For returns without confirmation, the refund or replacement may not be processed;<br />
      <br /><br />
      3.4 Policy of Refunds & Replacements<br />
      a. For returns of US orders and if the product is in good condition, we'll charge a transaction fee (2.6% for credit card users, 3.6% for PayPal users, 3.5% for Affirm users) + shipping cost. f there are quality issues with your product, we will give you a full refund or one-time free replacement after you receive the goods;<br />
      b. After EcoFlow receives your refund request, we'll issue the refund within 14 business days after we receive your product. We will then notify you by email once your refund has been processed. If you don't receive the refund after 14 business days, please contact order@ecoflow.com;<br />
      c. After EcoFlow receives your product replacement request, we'll send a replacement product within 7 business days after receiving your product. Providing EcoFlow has sufficient stock, you'll be notified by email with logistics information. <br />
      <br /><br />

      3.5 Refunds & Replacements may not be provided when:<br />
      X The refund/replacement is requested after 30 days of receiving the product. <br />
      X The product is returned without confirmation by EcoFlow customer service team.<br />
      X Legal proof-of-purchase, receipts, or invoices are not provided, can’t be found, or are reasonably believed to have been forged or tampered with.<br />
      X A product sent to EcoFlow does not include all the original accessories, attachments, and packaging, or it contains items damaged by user error.<br />
      X Evidence is found of damage t caused by collision, scorching, or unauthorized use or modification of the product, including exposure to moisture or water, entry of other foreign items (including but not limited to oil, sand, etc.) or improper installation or operation of the product is found.<br />
      X Product labels, serial numbers, water damage marks, etc. show signs of tampering or alteration.<br />
      X Damage is caused by uncontrollable external factors, including fires, floods, high winds, lightning strikes, or traffic accidents.<br />
      X The product has not been sent back to EcoFlow within 15 calendar days after confirmation from EcoFlow.<br />
      X Other circumstances that are not stated in this policy but EcoFlow has sufficient proof to refuse.<br />
      <br /><br />
      `,
        },
        {
            key: 'p4',
            text: 'Repair Service',
            isContainTable: true,
        },
        {
            key: 'p5',
            text: 'Limited International Warranty Service',
            isContainTable: true,
        },
        {
            key: 'p6',
            text: 'Cross-Regional After-Sales Services',
            value: `
      a. Ecoflow does not provide global warranty for products, and the warranty service can only be fulfilled at a designated EcoFlow repair center.<br />
      b. To repair the product at an EcoFlow repair center and in the event that the product was purchased in another region, customers can still apply for a repair at an additional cost (depending on spare part availability). Some products do not support cross-regional repair even if the customer is willing to pay for the service. For more details, please contact EcoFlow Support.<br />
      c. Cross-regional replacement service is not available for different versions of the same product.<br />
      d. The customer will need to bear customs duties, taxes, customs clearance, and other costs incurred due to cross-regional repair, regardless of whether it is regarding the warranty repair service or the paid repair service.<br />
      <br /><br />
      `,
        },
        {
            key: 'p7',
            text: 'Refurbished Product Aftersales Policy',
            value: `
      a. All refurbished products meet the normal required standards for use and can be used just as with an ordinary unit. <br />
      b. Refurbished units are produced and certified by EcoFlow and can therefor benefit from the same after-sales services, including warranty. However, if a replacement is required, reasoning related to appearance, or applications without reason will not be accepted. <br />
      c. Customers should ensure the refurbished product has been purchased from an authorized seller. The serial number of the product should match our database records. If the product is not found in our database, the service will not apply. <br />
      <br /><br />
      `,
        },
        {
            key: 'p8',
            text: 'Logistics Policy',
            value: `
      a. Customers need to check the product for damages before signing for receival. If there are any problems, please contact EcoFlow and provide the corresponding certification or proof.
      When signing receival for products, the customer needs to check whether the product is intact and undamaged. If left unchecked, it will be deemed that the customer considers that the product is functioning and not damaged. If the product is damaged during transportation, please contact EcoFlow within 24 hours;
      <br /> b. In the event that the customer sends a product to EcoFlow without advance authorization from EcoFlow’s after-sales team, EcoFlow has the right to reject the package, and any loss or damage shall be covered by customer;
      <br /> c. If the customer sends a product back to EcoFlow by COD(cash-on-delivery) without authorization of EcoFlow in advance, the package may be rejected due to payment failure; the customer shall bear any direct or indirect loss during this operation;
      <br /> d. The customer shall send back the product to the specified and unique address according to instruction of the EcoFlow service team.In the event that a product is sent to any other address by mistake, EcoFlow shall not be responsible for safety or transferring of product, even if the address is relevant to EcoFlow;
      <br /> e. The customer needs to make sure that the receiving addresses are correct and are updated. If the receiving address provided by the customer are wrong, or the recipient refuses to receive the product, the loss caused shall be covered by the customer.
      <br /> f. Customs Clearance: EcoFlow will not bear any customs clearances incurred.
      <br /> <br /> `,
        },
        {
            key: 'p9',
            text: 'What to do Before Requesting After-Sales Service',
            value: `
      Before requesting after-sales service, the following steps must be taken:<br />
      √Follow the service procedures specified by EcoFlow;<br />
      √Follow the instruction of the EcoFlow service team and provide a product defect description and any relevant information of recipient;<br />
      √Remove all additional parts. Alterations and attachments are not covered under warranty;<br />
      √Ensure that the product or parts are free of any legal restrictions that prevent repair or replacement.<br />
      <br /><br />
      `,
        },
        {
            key: 'p10',
            text: 'What This After-Sales Policy Does Not Cover',
            value: `
      For some circumstances this policy does not cover, customer and EcoFlow shall discuss to find solution based on fact and proof.
      <br /><br />
      `,
        },
        {
            key: 'p11',
            text: 'Limitation of Liability',
            value: `
      WHEN RECEIVING SERVICE, EcoFlow IS RESPONSIBLE FOR LOSS OR DAMAGE TO YOUR PRODUCT ONLY WHILE IT IS IN EcoFlow'S POSSESSION OR IN TRANSIT, IF EcoFlow IS RESPONSIBLE FOR TRANSPORTATION.<br />
      UNDER NO CIRCUMSTANCES, AND NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY REMEDY SET FORTH HEREIN, SHALL EcoFlow, ITS AFFILIATES, SUPPLIERS, RESELLERS, OR SERVICE PROVIDERS BE LIABLE FOR ANY OF THE FOLLOWING EVEN IF INFORMED OF THEIR POSSIBILITY AND REGARDLESS OF WHETHER THE CLAIM IS BASED IN CONTRACT, WARRANTY, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY OF LIABILITY:<br />
      1) THIRD PARTY CLAIMS AGAINST YOU FOR DAMAGES;<br />
      2) SPECIAL, INCIDENTAL, PUNITIVE, INDIRECT OR CONSEQUENTIAL DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS, BUSINESS REVENUE, GOODWILL OR ANTICIPATED SAVINGS. IN NO CASE SHALL THE TOTAL LIABILITY OF EcoFlow, ITS AFFILIATES, SUPPLIERS, RESELLERS, OR SERVICE PROVIDERS FOR DAMAGES FROM ANY CAUSE EXCEED THE AMOUNT OF ACTUAL DIRECT DAMAGES, NOT TO EXCEED THE AMOUNT PAID FOR THE PRODUCT.
      THE FOREGOING LIMITATION DOES NOT APPLY TO DAMAGES FOR BODILY INJURY (INCLUDING DEATH), DAMAGE TO REAL PROPERTY OR DAMAGE TO TANGIBLE PERSONAL PROPERTY FOR WHICH EcoFlow IS LIABLE UNDER LAW.<br />
      AS SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
      <br /><br />
      `,
        },
        {
            key: 'p12',
            text: 'Your Other Rights',
            value: `This policy provides you with extra and specific legal rights. You may have other rights according to the applicable laws of your state or jurisdiction. You may also have other rights under a written agreement with EcoFlow. Nothing in this policy affects your statutory rights, including rights of consumers under laws or regulations governing the sale of consumer products that cannot be waived or limited by agreement.`,
        },
        {
            key: 'p13',
            text: 'Interpretation Rights',
            value: `* EcoFlow reserves the right of final interpretation of the above customers' after-sales policy.`,
        },
    ];
    const [anchorText, setAnchorText] = useState('Overview');
    const [tabActive, setTabActive] = useState(0);
    const [isShowNav, setIsShowNav] = useState(false);
    const { t } = useLang('shared');
    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_policy') }];

    const handleTabClick = (e: any, ind: number, text: string) => {
        const { className, offsetTop, offsetHeight } = e.target;
        const key = e.target.getAttribute('data-key');
        if (className && className === 'active') return false;

        const targetEle: any = document.querySelector('.tabs-ink-bar');
        if (targetEle.style) {
            targetEle.style.top = `${offsetTop}px`;
            targetEle.style.height = `${offsetHeight}px`;
        }

        setTabActive(ind);
        scrollToAnchor(`#${key}`);
        gtm.push({
            event: 'uaEvent',
            event_name: 'policy_navigation',
            navigation_name: text || '',
        });
    };

    const mHandleTabClick = (e: any, ind: number, text: string) => {
        const key = e.target.getAttribute('data-key');
        setAnchorText(text);
        setTabActive(ind);
        scrollToAnchor(`#${key}`);
        setIsShowNav(false);
        gtm.push({
            event: 'uaEvent',
            event_name: 'policy_navigation',
            navigation_name: text || '',
        });
    };

    useEffect(() => {
        if (!isMobile) {
            const targetEle: any = document.querySelector('.tabs-ink-bar');
            if (targetEle.style) {
                targetEle.style.height = `70px`;
                targetEle.style.top = '56px';
            }
        }
    }, []);

    return (
        <div className={`${css.supportPolicy}`}>
            {isMobile ? <SupportBannerH5 /> : <SupportBanner />}
            <Crum data={breadcrumbData} />
            <div className={`${css.accessories} container`}>
                <div className="accessories-box">
                    {isMobile ? <SupportTitleH5 title={lang.title} /> : <SupportTitle title={lang.title} />}
                    {isMobile && (
                        <div className={`policy-access-tab-top ${isShowNav ? 'nav-active' : ''}`} onMouseLeave={() => setIsShowNav(false)}>
                            <div className="policy-access-tab-top-wrapper" onClick={() => setIsShowNav(!isShowNav)}>
                                <span className="anchor-text">{anchorText}</span>
                                <div className="iconBox">
                                    <EFArrowDown />
                                </div>
                            </div>
                            {isShowNav && (
                                <div className="vertical-nav">
                                    <ul>
                                        {policyList.map((item: any, ind: number) => (
                                            <li
                                                key={ind}
                                                data-key={item.key}
                                                className={tabActive === ind ? 'active' : ''}
                                                onClick={(e) => mHandleTabClick(e, ind, item.text)}
                                            >
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="content">
                        <div className="policy-access-wrapper">
                            {!isMobile && (
                                <div className="policy-access-tab">
                                    <ul>
                                        {policyList.map((item: any, ind: number) => (
                                            <li
                                                key={ind}
                                                data-key={item.key}
                                                className={tabActive === ind ? 'active' : ''}
                                                onClick={(e) => handleTabClick(e, ind, item.text)}
                                            >
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="tabs-ink-bar tabs-ink-bar-animated"></div>
                                </div>
                            )}

                            <div className="policy-access-content" id="container">
                                {policyList.map((item: any, indx: number) => {
                                    if (item.isContainTable) {
                                        return <Fragment key={indx} id={item.key} tabActive={tabActive} isMobile={isMobile} locale={locale} />;
                                    } else {
                                        return (
                                            <div
                                                id={item.key}
                                                key={item.key}
                                                className={`policycontent-item policy-access-content-item ${
                                                    item.key == `p${parseInt(tabActive) + 1}` ? 'active' : ''
                                                }`}
                                            >
                                                <h3>{item.text}</h3>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.value,
                                                    }}
                                                    style={{ color: '#35404e' }}
                                                ></div>
                                            </div>
                                        );
                                    }
                                })}
                                <div className="footer-tip">
                                    {"This limited warranty policy only applies to EcoFlow's products purchased in the North America through formal channels"}
                                </div>
                            </div>
                        </div>
                    </div>
                    {isMobile ? <SupportContactUsH5 isShow={true} /> : <SupportContactUs isShow={true} />}
                </div>
            </div>
        </div>
    );
}

// 处理包含table内容的项
function Fragment({ id, tabActive, isMobile, locale }: any) {
    const p1Columns = [
        {
            title: 'DELTA Series',
            dataIndex: 'ds',
            key: 'DELTA Series',
        },
        {
            title: 'RIVER Series',
            dataIndex: 'rs',
            key: 'RIVER Series',
        },
        {
            title: 'Solar Panels',
            dataIndex: 'sp',
            key: 'Solar Panels',
        },
        {
            title: 'Ecosystem Products',
            dataIndex: 'ep',
            key: 'Ecosystem Products',
        },
        {
            title: 'Power Banks',
            dataIndex: 'pb',
            key: 'Power Banks',
        },
        {
            title: 'Accessories,  Extra Batteries',
            dataIndex: 'aeb',
            key: 'Accessories,  Extra Batteries',
        },
    ];

    const p1Data: any = [
        {
            key: 1,
            ds: 'DELTA Pro',
            rs: 'RIVER Pro',
            sp: '400W',
            ep: 'Smart Home Panel',
            pb: 'RIVER Bank',
            aeb: 'DELTA Pro Smart Extra Battery',
        },
        {
            key: 2,
            ds: 'DELTA Max',
            rs: 'RIVER Max',
            sp: '160W',
            ep: 'Smart Generator',
            pb: 'Rapid Power Bank',
            aeb: 'DELTA Max Smart Extra Battery',
        },
        {
            key: 3,
            ds: 'DELTA1000',
            rs: 'RIVER',
            sp: '110W',
            ep: 'Double Voltage Hub',
            pb: 'Rapid Plus Power Bank',
            aeb: 'RIVER Pro Extra Battery',
        },
        {
            key: 4,
            ds: 'DELTA Mini',
            rs: 'R600 Pro',
            sp: '85W',
            ep: 'EV X-Stream Adapter',
            pb: '',
            aeb: 'RIVER Extra Battery',
        },
        {
            key: 5,
            ds: 'DELTA',
            rs: 'R600 Max',
            sp: '60W',
            ep: 'Solar Tracker',
            pb: '',
            aeb: 'Cables & Chargers',
        },
        {
            key: 6,
            ds: '',
            rs: 'R600',
            sp: '50W',
            ep: '',
            pb: '',
            aeb: 'Cases',
        },
        {
            key: 7,
            ds: '',
            rs: 'RIVER 412',
            sp: '21W',
            ep: '',
            pb: '',
            aeb: '',
        },
        {
            key: 8,
            ds: '',
            rs: 'RIVER 370',
            sp: '',
            ep: '',
            pb: '',
            aeb: '',
        },
    ];

    const p2Colums = [
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'Category',
        },
        {
            title: 'Warranty',
            dataIndex: 'region',
            key: 'Warranty',
        },
    ];

    const p2Data = [
        {
            key: 1,
            category: 'R600/R600 Max/R600 Pro/EF-1500*',
            region: '36 months',
        },
        {
            key: 2,
            category: 'RIVER/RIVER Max/RIVER Pro',
            region: '24 months',
        },
        {
            key: 3,
            category: 'RIVER/RIVER Pro Extra Battery',
            region: '24 months',
        },
        {
            key: 4,
            category: 'RIVER 370/RIVER 412',
            region: '24 months',
        },
        {
            key: 5,
            category: isMobile ? 'RIVER Bank/Rapid Power Bank/\nRapid Plus Power Bank' : 'RIVER Bank/Rapid Power Bank/Rapid Plus Power Bank',
            region: '12 months',
        },
        {
            key: 6,
            category: 'DELTA Mini/DELTA',
            region: '24 months',
        },
        {
            key: 7,
            category: 'DELTA Max/DELTA Max Smart Extra Battery',
            region: '36 months',
        },
        {
            key: 8,
            category: 'DELTA Pro/DELTA Pro Smart Extra Battery',
            region: '60 months',
        },
        {
            key: 9,
            category: 'DELTA 2/DELTA 2 Smart Extra Battery',
            region: '60 months',
        },
        {
            key: 10,
            category: 'RIVER 2/RIVER 2 Max/RIVER 2 Pro',
            region: '60 months',
        },
        {
            key: 11,
            category: 'Smart Generator',
            region: '12 months',
        },
        {
            key: 12,
            category: 'Smart Generator (Dual Fuel)',
            region: '24 months',
        },
        {
            key: 13,
            category: 'Smart Home Panel',
            region: locale === 'us' || locale === 'ca' ? '3 years' : '24 months',
        },
        {
            key: 14,
            category: 'Cables/Chargers\n(inside the package/sold separately)',
            region: '12 months',
        },
        {
            key: 15,
            category: isMobile
                ? locale === 'us'
                    ? 'Solar Panels\n(400W/160W/110W/60W)'
                    : 'Solar Panels\n(400W/160W/110W/85W/60W/50W/21W)'
                : locale === 'us'
                ? 'Solar Panels(400W/160W/110W/60W)'
                : 'Solar Panels(400W/160W/110W/85W/60W/50W/21W)',
            region: '12 months',
        },
        {
            key: 16,
            category: '100W Rigid Solar Panel',
            region: '60 months',
        },
        {
            key: 17,
            category: '100W Flexible Solar Panel',
            region: '36 months',
        },
        {
            key: 18,
            category: 'Solar Tracker',
            region: '12 months',
        },
        {
            key: 19,
            category: 'Double Voltage Hub',
            region: '12 months',
        },
        {
            key: 20,
            category: 'EV X-Stream Adapter',
            region: '12 months',
        },
        {
            key: 21,
            category: isMobile ? 'Wave Portable Air Conditioner/\nWave Add-On Battery' : 'Wave Portable Air Conditioner/Wave Add-On Battery',
            region: '12 months',
        },
        {
            key: 22,
            category: 'Power Hub/Power Kits Console',
            region: '60 months',
        },
        {
            key: 23,
            category: '2kWh/5kWh LFP Battery',
            region: '60 months',
        },
    ];

    const p4Colums = [
        {
            title: 'Product',
            dataIndex: 'product',
            key: 'Product',
        },
        {
            title: 'Shipping Cost',
            dataIndex: 'cost',
            key: 'Shipping Cost',
        },
    ];

    const p4Data = [
        {
            key: 1,
            product: 'DELTA',
            cost: '$65',
        },
        {
            key: 2,
            product: 'RIVER 370',
            cost: '$40 ',
        },
        {
            key: 3,
            product: 'RIVER',
            cost: '$30',
        },
        {
            key: 4,
            product: 'RIVER Extra Battery',
            cost: '$15',
        },
        {
            key: 5,
            product: 'RIVER Max',
            cost: '$35',
        },
        {
            key: 6,
            product: 'RIVER Pro',
            cost: '$35',
        },
        {
            key: 7,
            product: 'RIVER Pro Extra Battery',
            cost: '$35',
        },
        {
            key: 8,
            product: 'DELTA Max',
            cost: '$70',
        },
        {
            key: 9,
            product: 'DELTA Pro',
            cost: '$90',
        },
        {
            key: 10,
            product: 'RIVER Plus',
            cost: '$30',
        },
        {
            key: 11,
            product: 'RIVER Max Plus',
            cost: '$35',
        },
        {
            key: 12,
            product: '110W/160W solar panel',
            cost: '$40',
        },
        {
            key: 13,
            product: 'Other Products',
            cost: '$16',
        },
    ];
    const p5Colums = [
        {
            title: 'Warranty Item',
            dataIndex: 'wi',
            key: 'Warranty Item',
        },
        {
            title: 'Purchase Country/Region',
            dataIndex: 'pcr',
            key: 'Purchase Country/Region',
        },
        {
            title: 'Countries/Regions for International Warranty Service',
            dataIndex: 'crfiws',
            key: 'Countries/Regions for International Warranty Service',
        },
    ];

    const p5Data = [
        {
            key: 1,
            wi: 'Replacement Under Warranty',
            pcr: 'Supported',
            crfiws: 'Supported',
        },
        {
            key: 2,
            wi: 'Repair Under Warranty',
            pcr: 'Not Supported',
            crfiws: 'Not Supported',
        },
        {
            key: 3,
            wi: 'Return and Refund',
            pcr: 'Supported',
            crfiws: 'Not Supported',
        },
    ];
    const p5Colums_2 = [
        {
            title: 'Purchase Country/Region',
            dataIndex: 'pcr',
            key: 'Purchase Country/Region',
        },
        {
            title: 'Warranty Country/Region',
            dataIndex: 'wcr',
            key: 'Warranty Country/Region',
        },
        {
            title: 'Device Status',
            dataIndex: 'ds',
            key: 'Device Status',
        },
        {
            title: 'Eligible for International Warranty',
            dataIndex: 'efiw',
            key: 'Eligible for International Warranty',
        },
        {
            title: 'Warranty Rule for Main Device After Service',
            dataIndex: 'wrfmdas',
            key: 'Warranty Rule for Main Device After Service',
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'Remarks',
        },
    ];

    const p5Data_2 = [
        {
            key: 1,
            pcr: 'United States',
            wcr: 'Germany',
            ds: 'Within Warranty',
            efiw: 'Yes',
            wrfmdas: 'Continues original warranty period',
            remarks: 'Warranty is based on the rules of the purchase country/region (United States)',
        },
        {
            key: 2,
            pcr: 'United States',
            wcr: 'South Africa',
            ds: 'Within Warranty',
            efiw: 'No',
            wrfmdas: '/',
            remarks:
                'Warranty country/region is not within the supported international warranty service area; service must be done in the original purchase country',
        },
    ];
    const tabActiveN = `p${parseInt(tabActive) + 1}`;
    if (id === 'p1') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3 style={{ marginTop: 0 }}>Overview</h3>
                1.1 Purpose
                <br />
                This policy aims to improve your after-sales experience and standardize processes in order to provide high-quality and efficient services.
                <br />
                <br />
                1.2 Applicable Customers
                <br />
                Applicable customers are those who have purchased NA/US EcoFlow product(s) and request after-sales services directly from EcoFlow in this
                region. If some eCommerce platforms, sales channels or customers who promised different after-sales policies with the following description,
                please contact your place of purchase to implement your warranty.
                <br />
                <br />
                NA Region Scope: The Contiguous US
                <br />
                <br />
                1.3 NA After-Sales Service Contact Information
                <br />
                NA customers can reach Ecoflow by the following contact:
                <br />
                Phone Number: +1 (800)-368-8604 (9:00AM-9:00PM EST)
                <br />
                E-mail: support@ecoflow.com
                <br />
                Ecoflow.com Online Support: Mon-Fri 10 am-7pm (EST)
                <br />
                Ecoflow App: https://ecoflow.com/pages/ecoflow-app
                <br />
                <br />
                <br />
                1.4 Product Series
                <br />
                <br />
                <Table columns={p1Columns} dataSource={p1Data} pagination={false} bordered={true} />
                <br />
                <br />
                *Table updated September 2021
            </div>
        );
    } else if (id === 'p2') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Warranty Period</h3>
                2.1 Warranty Period of Main Parts
                <br />
                <br />
                <Table columns={p2Colums} dataSource={p2Data} pagination={false} bordered={true} />
                <br />
                *Table updated September-2021;
                <br />
                **For DELTA Pro&DELTA Max/RIVER/DELTA series Kickstarter backers, EcoFlow offers an exclusive warranty period base on campaign commitment.
                <br />
                <br />
                2.2 Warranty Period Determination
                <br />
                a. Valid Proof of Purchase:
                <br />
                The following proof of purchase documents are required when customers claim warranty from EcoFlow:
                <br />
                1) Orders placed on EcoFlow.com: Sales invoice, order confirmation email and logistics information that clearly show the description of the
                product, price, sales channel, sales date and delivery date;
                <br />
                2) Products purchased from other channels: Valid purchase invoice, logistics evidence, or order number(s) confirmed by EcoFlow customer service
                team;
                <br />
                b. Warranty Start Date:
                <br />
                1) The warranty period begins the day your product is received at your delivery address.
                <br />
                2) Most EcoFlow products have a warranty over 12 months long. If you cannot locate shipping information to prove your warranty start date, we
                will default to a 30 days shipping time from your date of purchase, with the warranty starting 30 days after purchase.
                <br />
                c. Defect Reporting Date:
                <br />
                Whether or not your defect is covered under warranty depends on the date you report your defect. The defect reporting date can be from one of
                the following methods: Phone contact date, support email date or app report date. The earliest of which shall be considered your defect report
                date.
                <br />
                d. Unconditional Return Period:
                <br />
                You can return your product unconditionally within 30 calendar days of receiving your product provided it was ordered on EcoFlow.com in the
                contiguous US.
                <br />
                e. Warranty Repair Service Period:
                <br />
                According to the above-mentioned warranty table in section 2.1, products under warranty that do not meet the requirements of refund or
                replacement can request a warranty repair service.
                <br />
                f. The replacement product or parts will either inherit the remaining warranty period of the original product, or be given at least 3 months
                warranty, the longer period shall prevail.
            </div>
        );
    } else if (id === 'p4') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Repair Service</h3>
                4.1 Warranty Repair Service
                <br />
                a. If the product is under warranty the customer can request EcoFlow to repair their product in the event that it is not functioning as
                intended;
                <br />
                b. The customer can request repair when the following conditions are met:
                <br />
                √The product has a manufacturing defect during the warranty period.
                <br />
                √A valid proof-of-purchase, receipt, or order number for the warranty service is provided.
                <br />
                c.In the following cases, EcoFlow will not be able to provide free warranty services for your product during the warranty period:
                <br />
                a. The warranty period of the product has expired.
                <br />
                b. Unable to provide proof of purchase and relevant documents, or unable to prove that the product is within the warranty period.
                <br />
                c. Product identification information (such as barcodes, model numbers, warning icons, etc.) has been altered or worn off.
                <br />
                d. Unauthorized modifications to product software or hardware, use of unofficial or unauthorized accessories, third-party devices, use of the
                product under conditions not recommended by the official guidelines, and any damage caused by failure to follow instructions in the quick guide,
                user manual (or other relevant documents), improper use, maintenance, etc.
                <br />
                e. Damage caused by force majeure (including but not limited to earthquake, fire, flood, war, lightning strike, theft, etc.).
                <br />
                f. Any failure or damage to the product caused by external factors such as collisions and burns, including but not limited to exposure to high
                temperature and humidity, oily or smoky environment, intrusion of foreign substances (liquids, corrosive substances, oxidation, insects, sand,
                etc.), improper installation or operation.
                <br />
                g. Damage caused by repairs by persons or institutions not authorized by EcoFlow.
                <br />
                h. Natural damages to the surface of the product (abrasions, scratches, etc.) that do not affect its functionality and normal usage.
                <br />
                i. Unauthorized alteration of warranty cards or warranty statements.
                <br />
                j. The product has been found to be free from defects after all appropriate testing performed by EcoFlow or a repair service center authorized
                by EcoFlow.
                <br />
                k. Products that have been modified or disassembled without authorization.
                <br />
                l. Products purchased from unauthorized resellers.
                <br />
                m. Non-commercial versions of the product are not covered by the warranty.
                <br />
                n. The product has not been sent back to EcoFlow 15 calendar days after warranty repair confirmation from EcoFlow.
                <br />
                o. Complimentary gifts included with the order are not covered under EcoFlow's commercial warranty policy and do not affect the statutory rights
                enjoyed by consumers in accordance with the law.
                <br />
                p. Other circumstances not listed in this Policy but EcoFlow has reasonable grounds to refuse the request.
                <br />
                4.2 Paid Repair
                <br />
                Paid repair is required in the following situations:
                <br />
                a. The product is warranty has expired.
                <br />
                b. All conditions that do not belong to Warranty Repair Service.
                <br />
                4.3 Quotation criterion of paid repair.
                <br />
                Paid repair is required for conditions that are not covered by Warranty Repair Service. Reasonable cost will be charged with the following
                categories:
                <br />
                a. Spare parts cost.
                <br />
                b. Labor cost.
                <br />
                c. Logistics cost.
                <br />
                Logistics costs can be referenced. Cost is based on the weight and volume of the product:
                <br />
                <br />
                <Table columns={p4Colums} dataSource={p4Data} pagination={false} bordered={true} />
            </div>
        );
    } else if (id === 'p5') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Limited International Warranty Service</h3>
                <span className="bold-font">Policy Overview</span>
                <br />
                <div>
                    <p>
                        The international warranty service for EcoFlow products is designed for users who use the products outside of the original purchase
                        location. To provide a premium service experience, consumers can enjoy this warranty service for designated devices in specific
                        countries/regions that support international warranty services.
                    </p>
                </div>
                <br />
                <span className="bold-font">Countries/Regions Supporting International Warranty</span>
                <div>
                    <p>
                        Asia: <span className="bold-font">Mainland China</span> (excluding Hong Kong, Macao, and Taiwan),{' '}
                        <span className="bold-font">Japan, South Korea</span>
                    </p>
                    <p>
                        Europe: <span className="bold-font">Germany, United Kingdom</span> (excluding British Overseas Territories),
                        <span className="bold-font"> France</span> (excluding French Overseas Territories), <span className="bold-font">Italy, Spain</span>{' '}
                        (excluding Spanish Overseas Territories)
                    </p>
                    <p>
                        North America: <span className="bold-font">Canada, United States </span>(excluding Puerto Rico, Guam, Hawaii, and Alaska)
                    </p>
                    <p>
                        Oceania: <span className="bold-font">Australia</span>
                    </p>
                    <p>
                        * Devices must be within the Warranty Period, and both the purchase location and the service location must be within the above-listed
                        countries/regions to be eligible for international warranty service.
                    </p>
                    <p>
                        * French Overseas Territories: New Caledonia, Wallis and Futuna, French Polynesia, Clipperton Island, Mayotte, Réunion, Saint Pierre and
                        Miquelon, French Guiana, Saint Martin (French part), Saint Barthélemy, Guadeloupe, Martinique.
                    </p>
                    <p>* Spanish Overseas Territories: Canary Islands, Ceuta, Melilla.</p>
                    <p>
                        * British Overseas Territories: Anguilla, Bermuda, British Virgin Islands, Cayman Islands, Montserrat, Turks and Caicos Islands,
                        Falkland Islands, South Georgia and the South Sandwich Islands, Saint Helena, Gibraltar, British Antarctic Territory, Pitcairn Islands,
                        Akrotiri and Dhekelia.
                    </p>
                </div>
                <br />
                <span className="bold-font">International Warranty Scenarios and Service Coverage</span>
                <br />
                <br />
                <Table columns={p5Colums} dataSource={p5Data} pagination={false} bordered={true} />
                <br />
                <div>
                    <p>
                        <span className="bold-font">Eligible Users: </span>All consumers who purchase through EcoFlow or EcoFlow's officially authorized
                        channels (including new and refurbished devices).
                    </p>
                    <p>
                        <span className="bold-font">Supported Models: </span>EcoFlow RAPID Pro Power Bank (20,000mAh, 230W, 100W Built-in Cable), EcoFlow RAPID
                        Pro Power Bank (27,650mAh, 300W, 140W Built-in Cable), EcoFlow RAPID Pro X Power Bank (27,650mAh, 300W).
                    </p>
                    <p>
                        <span className="bold-font">Warranty Within Coverage: </span>Consumers must provide valid proof of purchase (electronic or paper
                        invoice, order number, etc.) and the device serial number. Upon confirmation by the local official customer service that warranty
                        conditions are met, consumers are eligible for&nbsp;
                        <span className="bold-font">
                            International warranty service (which covers main device hardware only; and accessories and software are excluded).{' '}
                        </span>
                        Warranty determination is subject to the policies of EcoFlow&apos;s local service center. Devices or part(s) repaired or replaced during
                        the Warranty Period will be warranted for the remainder of the original Warranty Period from the date of repair or replacement.
                    </p>
                    <p>
                        <span className="bold-font">Warranty Scope: </span>Hardware damage or functional failure caused by product quality issues.
                    </p>
                    <p>
                        <span className="bold-font">Warranty Period: Determined by the device&apos;s original purchase location</span> (effective from the date
                        of purchase), unless otherwise required by local laws and regulations. Replacement devices inherit the remaining Warranty Period of the
                        original product and will not restart the warranty duration. If the purchase date cannot be confirmed, the Warranty Period will start
                        from the manufacturing date (based on serial number) plus 90 days.
                    </p>
                    <p>
                        <span className="bold-font">Local Warranty Service: </span>Follows the existing warranty policy of the product&apos;s purchase
                        country/region.
                    </p>
                    <p>
                        * The length of warranty coverage and post-replacement warranty duration are subject to the relevant laws and regulations of the
                        country/region. In case of conflict, local laws and regulations prevail.
                    </p>
                </div>
                <br />
                <span className="bold-font"> Warranty Exclusions</span>
                <div>
                    <p>
                        <span className="bold-font">The following scenarios are not covered under the international warranty:</span>
                    </p>
                    <br />
                    <p>1. Device models that do not support international warranty;</p>
                    <p>2. Failure to provide valid proof of purchase;</p>
                    <p>3. Service location outside the eligible coverage area;</p>
                    <p>4. Devices sold through unofficial or unauthorized channels;</p>
                    <p>5. Any unauthorized modification, disassembly, or repair without EcoFlow’s permission;</p>
                    <p>6. Lost or stolen products;</p>
                    <p>7. Damage caused by misuse (including but not limited to dropping, water damage, extreme temperatures, improper operation);</p>
                    <p>8. External damages (including but not limited to natural disasters such as earthquakes, tsunamis, tornadoes);</p>
                    <p>9. Non-quality-related issues;</p>
                    <p>10. Products that have exceeded the Warranty Period;</p>
                    <p>11. Free products;</p>
                    <p>12. Return and refund services.</p>
                </div>
                <br />
                <span className="bold-font"> Policy Description</span>
                <div>
                    <p>
                        1. The international warranty service only covers warranty support for designated models (main device hardware only, excluding
                        accessories and software). It does not include return or refund services. Other services are subject to the policies of the service
                        location.
                    </p>
                    <p>2. Accessory warranties are subject to the service policy of the purchase location.</p>
                    <p>
                        3. This international warranty policy does not affect consumers' existing warranty rights in the country/region where the product was
                        purchased.
                    </p>
                    <p>
                        4. The start date of international warranty service in each country/region is based on the official product release date in that
                        country/region.
                    </p>
                    <p>
                        5. You must authorize EcoFlow to access your relevant information and provide necessary warranty details; otherwise, EcoFlow’s official
                        service center reserves the right to refuse service.
                    </p>
                    <p>
                        6. For devices purchased through unauthorized channels, service centers reserve the right to refuse service. Please purchase products
                        through officially recognized channels.
                    </p>
                    <p>
                        7. If the product has quality defects or flaws during the warranty period and does not fall into the above exclusion scenarios, and if
                        it cannot be repaired after inspection by EcoFlow, EcoFlow has the right to choose to replace it with a new device of the same model or
                        a refurbished device of the same model for you.
                    </p>
                    <p>
                        8. Any defective product that is replaced becomes the property of EcoFlow. You must return it according to EcoFlow’s instructions. If
                        you do not follow the return instructions or refuse to return the product, EcoFlow reserves the right to deny any further claims,
                        including refusing to provide warranty service for the replacement unit.
                    </p>
                    <p>
                        9. Due to differences in systems, regulations, product versions, and packaging requirements between countries/regions, the process and
                        outcome of this service may lead to differences in packaging, appearance, or features. Safety certifications or markings printed on the
                        product or packaging may apply only in the region providing the warranty service and may differ from those required in the purchase
                        location.
                    </p>
                    <p>
                        10. When carrying the product across borders, users must comply with local customs laws and regulations and bear any resulting costs and
                        duties.
                    </p>
                    <p>
                        11. Supported device models and countries/regions under this service are subject to change. Please refer to the latest official
                        announcements.
                    </p>
                    <p>12. The information on this page is subject to change without prior notice. EcoFlow reserves the right to the final interpretation.</p>
                </div>
                <br />
                <span className="bold-font"> Email Us</span>
                <div>
                    <p>
                        <span className="bold-font">NA: </span>
                        <a href="mailto:support@ecoflow.com">support@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">DE/UK/FR/IT/ES: </span>
                        <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">AU: </span>
                        <a href="mailto:support.au@ecoflow.com">support.au@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">JP: </span>
                        <a href="mailto:support.jp@ecoflow.com">support.jp@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">KR: </span>
                        <a href="mailto:support.kr@ecoflow.com">support.kr@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">CN: </span>
                        <a href="mailto:guoneikefu@ecoflow.com">guoneikefu@ecoflow.com</a>
                    </p>
                </div>
                <br />
                <span className="bold-font">Appendix: Cross-Country/Region Warranty Examples</span>
                <br />
                <br />
                <Table columns={p5Colums_2} dataSource={p5Data_2} pagination={false} bordered={true} />
            </div>
        );
    }
    return <div></div>;
}

function scrollToAnchor(target: string) {
    const ele: any = document.querySelector(target);
    const container: any = document.querySelector('#container');
    if (ele) {
        container.scrollTop = ele.offsetTop - 68;
    }
}
